export default __webpack_public_path__ + "static/media/logo192x192.6032b57f.png";